module.exports = __webpack_public_path__ + "img/radio-button-fill.a53b0d2b.svg";